<div
  id="carouselExampleCaptions"
  class="carousel slide"
  [dir]="language === 'ar' ? 'rtl' : 'ltr'"
  data-bs-ride="carousel"
>
  <div class="carousel-inner">
    <div
      *ngFor="let item of services; let i = index"
      class="carousel-item position-relative"
      [class.active]="i === 0"
    >
      <div class="hero-img-wrapper">
        <img
          [src]="item?.imageIconPath"
          [alt]="item?.imageAlt"
          class="d-block w-100 hero-img"
          loading="lazy"
        />
        <div class="img-blur-overlay"></div>
        <div class="gradient-overlay"></div>
      </div>

      <div
        class="carousel-caption d-flex flex-column justify-content-center align-items-start h-100 px-4 px-md-5 text-start"
      >
        <h1 class="hero-title display-6 text-uppercase">
          {{ item.titleTr }}
        </h1>
        <p class="display-5 sub-title text-uppercase">
          {{ item.summary }}
        </p>
        <app-app-button
          class="mt-3 text-white"
          [buttonText]="item.buttonText"
          [link]="getLinkUrl(item)"
          *ngIf="isDetails"
        ></app-app-button>
      </div>
    </div>
  </div>

  <button
    class="carousel-control-prev"
    type="button"
    data-bs-target="#carouselExampleCaptions"
    data-bs-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button
    class="carousel-control-next"
    type="button"
    data-bs-target="#carouselExampleCaptions"
    data-bs-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
